export default __webpack_public_path__ + "static/media/timelinePlus.07f00f48.svg";